import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Dropdown, Menu } from 'antd';
import { InputModelWithSource } from '../../models';
import { CheckIconBold, CollapseArrowDown } from '../../../custom_shared/icons';
import { useAppStore } from '../../stores';
import './SignedShareTypeInput.less';

interface Props {
    input: InputModelWithSource;
}

const SignedShareTypeInput: React.FC<Props> = ({ input }) => {
    const { actionStore } = useAppStore();

    const [menuVisible, setMenuVisible] = React.useState(false);

    const moreActionsMenu = (
        <Menu onClick={() => setMenuVisible(false)}>
            {input.sourceProvider.options.map(option => (
                <Menu.Item
                    key={option.value}
                    onClick={() => {
                        input.setValue(option.value);
                        actionStore.changeSignedShareType(input.worksheetId, input.nodeId);
                    }}
                >
                    <div className="dropdown-icon-container">
                        {option.value === input.value && <CheckIconBold width={16} height={16} color="#000" />}
                    </div>
                    <span className="dropdown-label">{option.label}</span>
                </Menu.Item>
            ))}
        </Menu>
    );

    const label = React.useMemo(
        () => input.sourceProvider.options.find(option => option.value === input.value)?.label ?? '',
        [input.value, input.sourceProvider.options]
    );

    return (
        <Dropdown
            overlayClassName="signed-share-type-input-dropdown"
            placement="topRight"
            visible={menuVisible}
            overlay={moreActionsMenu}
            onVisibleChange={setMenuVisible}
            trigger={['click']}
            disabled={input.node.worksheet.isLocked}
        >
            <div className="signed-share-type-input-container">
                <span className="signed-share-type-input-label">{label}</span>
                <CollapseArrowDown width={16} height={16} color="#717887" />
            </div>
        </Dropdown>
    );
};

export default observer(SignedShareTypeInput);
